export var VERSION = '2.37.1';
//# sourceMappingURL=version.js.map